/**
 * Placeholder for contact extender
 */

export default function () {}


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/plugin?media-sidebar-contact-extender!./common/js/src/edge/platform/widgets/mediasidebar/ContactExtenderDefaultService.js
// module id = 500
// module chunks = 0